import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'

import classNames from './common.css'
import { fetchPlaylists, addAlbumToList, removeAlbumFromList, saveList } from '../../redux/playlists'
import LoadingSpinner from '../LoadingSpinner'
import ErrorMessage from '../ErrorMessage'
import Icon from '../Icon'
import { pluralize } from '../../utils/string'
import { updateAlbumLists } from '../../utils/lists'

class AlbumLists extends Component {
  state = {
    checked: this.props.albumLists,
    createList: '',
    success: false,
    submitting: false
  }
  componentDidMount () {
    const { lists, fetchPlaylists } = this.props
    if (!lists) {
      fetchPlaylists()
    }
  }
  componentWillReceiveProps (nextProps) {
    const { albumLists } = this.props
    if (!albumLists && nextProps.albumLists) {
      this.setState({
        checked: nextProps.albumLists
      })
    }
    if (albumLists && nextProps.albumLists && nextProps.albumLists.length - albumLists.length === 1) {
      // New list created
      // Add new list ID to checked state array
      // WARNING: This assumes new list is last in the array, if default list order changes this will break
      this.setState({
        checked: this.state.checked.concat(nextProps.albumLists[nextProps.albumLists.length - 1])
      })
    }
  }
  onSubmit = () => {
    const { id, lists, addAlbumToList, removeAlbumFromList, saveList } = this.props
    const { checked, createList } = this.state
    this.setState({
      submitting: true
    })
    return updateAlbumLists({
      albumID: id,
      checked,
      createList,
      lists,
      addAlbumToList,
      removeAlbumFromList,
      saveList
    }).then(() => {
      this.setState({
        success: true,
        submitting: false,
        createList: ''
      })
    })
  }
  // TODO: Replace this list with Checklist component
  renderList = list => {
    const { checked } = this.state
    const isChecked = checked.indexOf(list.id) !== -1
    const onCheck = () => this.setState({ checked: checked.concat(list.id), success: false })
    const onUncheck = () => this.setState({ checked: checked.filter(id => id !== list.id), success: false })
    const structure = JSON.parse(list.json_data)
    return (
      <li key={list.id}>
        <button
          className={classNames.user}
          onClick={isChecked ? onUncheck : onCheck}>
          <div style={{ flex: 1 }}>
            <div className={classNames.userName}>
              {list.name}
            </div>
            <div className={classNames.userEmail}>
              {pluralize(structure.albums.length, 'album')}
              {structure.playlistsOnly &&
                ', for playlist albums only'
              }
              <Link to={`/groups/${list.id}`} className={classNames.editLink}>
                Edit
              </Link>
            </div>
          </div>
          <div className={isChecked ? classNames.checkboxChecked : classNames.checkbox}>
            {isChecked &&
              <Icon icon='tick' className={classNames.tick} size={16} />
            }
          </div>
        </button>
      </li>
    )
  }
  render () {
    const { lists, fetching, error, fetchPlaylists, id } = this.props

    if (!lists || fetching) {
      return <LoadingSpinner />
    }

    if (error) {
      return (
        <ErrorMessage
          message='There was an error fetching album groups'
          onRetry={fetchPlaylists}
        />
      )
    }

    const { createList, success, submitting } = this.state

    return (
      <div className={classNames.page}>
        <label>Album groups</label>
        <ul>
          {lists.map(this.renderList)}
        </ul>
        <label>
          Add to new group
          <input
            type='text'
            value={createList}
            onChange={e => this.setState({ createList: e.target.value })}
          />
        </label>
        {success &&
          <p className={classNames.note}>Album groups were successfully updated</p>
        }
        <div className={classNames.buttons}>
          <Link to={`/album/${id}`} className={success ? classNames.button : classNames.backButton}>
            {success ? 'Done' : 'Cancel'}
          </Link>
          {!success &&
            <button onClick={this.onSubmit} className={classNames.button} disabled={submitting}>
              {submitting ? 'Adding To Groups…' : 'Add To Groups'}
            </button>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ playlists }) => {
  return {
    fetching: playlists.fetching,
    error: playlists.error
  }
}

const mapDispatchToProps = {
  fetchPlaylists,
  addAlbumToList,
  removeAlbumFromList,
  saveList
}

export default connect(mapStateToProps, mapDispatchToProps)(AlbumLists)



// WEBPACK FOOTER //
// ./src/components/album/AlbumLists.js